import { render, staticRenderFns } from "./AMSTooltip.vue?vue&type=template&id=107871e6&"
import script from "./AMSTooltip.vue?vue&type=script&lang=ts&"
export * from "./AMSTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./AMSTooltip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VLayout,VTooltip})
